module.exports = __webpack_public_path__ + "static/media/pe.5156eee1.svg";